<template>
    <div class="card-container">
        <common-top-form :model="formModel" @success="onSuccess" :submitService="submitService" :submitData="submitData"
                        :show="false">
            <select-organs v-model="formModel.tatSimpleId"></select-organs>
            <el-form-item label="手机号">
                <el-input type="text" maxlength="20" v-model="formModel.memPhone" placeholder="请输入手机号"></el-input>
            </el-form-item>
            <el-form-item label="订单号">
                <el-input type="text" maxlength="50" v-model="formModel.orderNo" placeholder="请输入订单号"></el-input>
            </el-form-item>
            <el-form-item label="会员名称">
                <el-input type="text" maxlength="20" v-model="formModel.memName" placeholder="请输入会员名称"></el-input>
            </el-form-item>
            <el-form-item label="升级类型">
                <el-select v-model="formModel.upType">
                    <el-option
                        v-for="item in upTypes"
                        :key="item.dictKey"
                        :label="item.dictValue"
                        :value="item.dictKey">
                    </el-option>
                </el-select>
            </el-form-item>
            <!--</el-row>-->
            <el-form-item label="升级日期">
                <el-date-picker
                    v-model="formModel.time"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                </el-date-picker>
            </el-form-item>
        </common-top-form>
        <common-table :data="tableData" ref="commonTable" @handleChange="getPage">
            <!--<el-table-column prop="tatSimpleName" label="机构简称" min-width="100" show-overflow-tooltip></el-table-column>-->
            <el-table-column prop="memId" label="会员名称" min-width="100" show-overflow-tooltip
                             :formatter="formatterTableData"></el-table-column>
            <el-table-column prop="phoneNumber" label="会员电话" min-width="130" show-overflow-tooltip
                             :formatter="formatterTableData">
                <template slot-scope="scope">
                    <p>{{doUnicode(scope.row.phoneNumber)}}</p>
                </template>
            </el-table-column>
            <el-table-column prop="oldLevel" label="原级别" min-width="100" show-overflow-tooltip
                             :formatter="formatterTableData"></el-table-column>
            <el-table-column prop="newLevel" label="新级别" min-width="100" show-overflow-tooltip
                             :formatter="formatterTableData"></el-table-column>
            <el-table-column prop="createTime" label="升级时间" min-width="160"
                             :formatter="formatterTableData"></el-table-column>
        </common-table>
    </div>
</template>

<script>
    import CommonTopForm from 'components/common/CommonTopForm'
    import CommonTable from 'components/common/CommonTable'
    import SelectOrgans from 'components/business/SelectOrgans'
    import FinanceService from 'service/FinanceService'
    import TimeRange from 'service/constant/TimeRange'
    import StatisticsService from 'service/StatisticsService'
    import OrganService from 'service/OrganService'
    import {loadMixin, dialogMixin} from "mixin";
    import {mapGetters} from 'vuex'

    export default {
        name: "uplevelrecord",
        components: {
            CommonTopForm, CommonTable, SelectOrgans
        },
        data() {
            return {
                formModel: {
                    tatSimpleId: '',
                    memName: '',
                    orderNo: '',
                    memPhone: '',
                    upType: '',
                    time: TimeRange.dayRange,
                },
                upTypes: [],
                tatSimpleNames: [],
                topTatSimpleNames: [],
                all: [{
                    id: '',
                    simpleName: '全部'
                }],
                tableData: [],
                formDialogTitle: '',
                dialogRules: {},
                dialogModel: {},
                time: '',
                params: {},
                page: {},
                submitService: FinanceService.memUpSecond,
                isPage: false,
                centerDialogVisible: false,
                dialogAmount: 0
            }
        },
        inject: ['reload'],
        mixins: [loadMixin, dialogMixin],
        mounted() {
            this.load();
        },
        computed: {
            submitData() {
                if (this.formModel.time == null || this.formModel.time == '') {
                    this.formModel.time = [];
                }
                const params = {
                    memPhone: this.formModel.memPhone.trim(),
                    memName: this.formModel.memName.trim(),
                    orderNo: this.formModel.orderNo.trim(),
                    upType: this.formModel.upType,
                    tatSimpleId: this.formModel.tatSimpleId,
                    startDate: this.formModel.time[0],
                    endDate: this.formModel.time[1],
                    current: this.isPage ? this.page.currentPage : 1,
                    size: this.page.pageSize,
                };

                if (this.formModel.time.length == 0) {
                    delete params.startDate;
                    delete params.endDate;
                }

                return params;
            },
            ...mapGetters(['userId']),
        },
        methods: {
            formatTranTypee(row, column, cellValue) {
                let value = '';
                this.upTypes.forEach(item => {
                    if (item.dictKey == cellValue) {
                        value = item.dictValue;
                    }
                });
                return value ? value : '--';
            },
            load() {
                this.formModel = {
                    tatSimpleId: '',
                    memName: '',
                    memPhone: '',
                    orderNo: '',
                    upType: '',
                    time: TimeRange.dayRange,
                };
                this.page = this.$refs.commonTable.page;
                this.getSimpleNames();
                this.getTypeNames('upType', (res) => {
                    this.upTypes = [...[{
                        dictKey: '',
                        dictValue: '全部'
                    }], ...res];
                });
                this.getList();
            },
            getPage() {
                this.isPage = true;
                this.getList();
            },
            getList() {
                this.doLoad(this.submitService, this.submitData, res => {
                    this.doCheck(res, res => {
                        const result = res.contents;
                        this.tableData = result.rows;

                        this.page.currentPage = result.current;
                        this.page.pageSize = result.size;
                        this.page.total = result.total;
                        this.isPage = false;
                    });
                }, '信息获取失败')
            },
            onSuccess(data) {
                this.doCheck(data, res => {
                    const result = res.contents;
                    this.tableData = result.rows;

                    this.page.currentPage = result.current;
                    this.page.pageSize = result.size;
                    this.page.total = result.total;
                });
            },
            getSimpleNames() {
                this.doLoad(OrganService.simpleNames, '', res => {
                    this.doCheck(res, res => {
                        this.tatSimpleNames = res.contents;
                        this.topTatSimpleNames = [...this.all, ...res.contents];
                    });
                }, '信息获取失败')
            },
            goDetail(id) {
                this.$router.push({
                    name: 'settleemberleveldetail',
                    params: {
                        id: id
                    }
                })
                // this.formDialogTitle = '返佣详情';
                // this.centerDialogVisible = true;
            },
        }
    }
</script>

<style scoped>
    .inner-button {
        position: absolute;
        right: 10px;
        z-index: 1;
    }

    .orderNo {
        text-overflow: ellipsis;
        width: 100%;
        overflow: hidden;
    }
</style>



// WEBPACK FOOTER //
// src/view/page/FinanceManage/UpLevelRecord.vue